import {
  getAllBeefCircle, deleteCircleBackend, deleteCircleLikeBackend, getBuyerOfferList, getSellerOfferList, getBuyerOfferDetail, getSellerOfferDetail,
  updateBuyerOffer, updateSellerOffer, getSellerOfferMatchList, matchEntrustBtcOffer,
  identityValidate, getOrderAppendix, getBackendBuyerOffers, offerSmartPush, offerBtcPush,
  getImporterExporter, getCompanyRoleInfo, sendAssemblyOffer, sendFuturesAssemblyOffer,
  getAssemblyOffer, getExporterState, getImporterState, sendCounterOffer, sendCounterToExporter,
  getSpotAsmOfferBuyerState, getOfferNotes, addOfferNote, updateOfferNature, importCompanyCustomsData,
  getCompanyCustomsData, getBackendCompanyCustomsData, getGoodsSourceUpdateInfo, importImporters,
  getBackendImporters, importTradingReference, getBackendTradingReference, getBackendEmail,
  getBackendComments, updateBackendEmailState, updateBackendComments, getUserCollection,
  updateEmailInfo, addRealTimeSource, addBuyerOffer, deleteCircleReviewBackend, clearCutsBrochureStatus, readBeefCircleReviews,
  getAllBeefChat, getBeefChatDetail, updateChatManageStatus, deleteBackendBuyerOffers, topBeefCircle, getChatUserDetail, getBeefCircleConversationRecordList
} from '@/api/trade'

const bdnote = {
  state: {
    total: 0,
    rows: [],
    row: {},
    assemblyList: [],
    quantity: 0,
    exporters: [],
    reviews: [],
    chatRows: [],
    chatTotal: 0
  },
  mutations: {
    SET_TOTAL: (state, total) => {
      state.total = total
    },
    SET_ROWS: (state, rows) => {
      state.rows = rows
    },
    SET_ROW: (state, row) => {
      state.row = row
    },
    SET_ASSEMBLYLIST: (state, list) => {
      state.assemblyList = list
    },
    SET_QUANTITY: (state, quantity) => {
      state.quantity = quantity
    },
    SET_EXPORTERS: (state, exporters) => {
      state.exporters = exporters
    },
    SET_REVIEWS: (state, reviews) => {
      state.reviews = reviews
    },
    SET_CHATTOTAL: (state, total) => {
      state.chatTotal = total
    },
    SET_CHATROWS: (state, rows) => {
      state.chatRows = rows
    }
  },
  actions: {
    // 添加到出口商列表
    AddToExporters({ commit }, params) {
      commit('SET_EXPORTERS', params)
    },
    // 添加到求购列表
    AddToAssemblyList({ commit }, params) {
      let quantity = 0
      params.forEach(e => {
        quantity += e.Quantity
      })
      commit('SET_QUANTITY', quantity)
      commit('SET_ASSEMBLYLIST', params)
    },
    // 查询所有必孚圈
    GetAllBeefCircle({ commit }, params) {
      return new Promise((resolve, reject) => {
        getAllBeefCircle(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetBeefCircleConversationRecordList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBeefCircleConversationRecordList(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除必孚圈
    DeleteCircleBackend({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteCircleBackend(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除必孚圈点赞
    DeleteCircleLikeBackend({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteCircleLikeBackend(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询待审核求购
    GetBuyerOfferList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBuyerOfferList(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询待审核供给
    GetSellerOfferList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getSellerOfferList(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询待审核求购详情
    GetBuyerOfferDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBuyerOfferDetail(params).then(response => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询待审核供给详情
    GetSellerOfferDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        getSellerOfferDetail(params).then(response => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改求购信息
    UpdateBuyerOffer({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateBuyerOffer(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改供给信息
    UpdateSellerOffer({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateSellerOffer(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询卖家意向匹配列表
    GetSellerOfferMatchList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getSellerOfferMatchList(params).then((response) => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 匹配委托BTC的报盘
    MatchEntrustBtcOffer({ commit }, params) {
      return new Promise((resolve, reject) => {
        matchEntrustBtcOffer(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 身份认证
    IdentityValidate({ commit }, params) {
      return new Promise((resolve, reject) => {
        identityValidate(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取附件
    GetOrderAppendix({ commit }, params) {
      return new Promise((resolve, reject) => {
        getOrderAppendix(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询报盘
    GetBackendBuyerOffers({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBackendBuyerOffers(params).then((response) => {
          commit('SET_ROWS', response.Data.Res)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除报盘
    DeleteBackendBuyerOffers({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteBackendBuyerOffers(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 大数据智推
    OfferSmartPush({ commit }, params) {
      return new Promise((resolve, reject) => {
        offerSmartPush(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 必孚推送
    OfferBtcPush({ commit }, params) {
      return new Promise((resolve, reject) => {
        offerBtcPush(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 根据名称查询进口商
    GetImporterExporter({ commit }, params) {
      return new Promise((resolve, reject) => {
        getImporterExporter(params).then((response) => {
          commit('SET_ROWS', response.Data.List)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 根据名称查询进口商
    GetCompanyRoleInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCompanyRoleInfo(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 发送集结单
    SendAssemblyOffer({ commit }, params) {
      return new Promise((resolve, reject) => {
        sendAssemblyOffer(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 发送集结单（期货）
    SendFuturesAssemblyOffer({ commit }, params) {
      return new Promise((resolve, reject) => {
        sendFuturesAssemblyOffer(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询集结单
    GetAssemblyOffer({ commit }, params) {
      return new Promise((resolve, reject) => {
        getAssemblyOffer(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询出口商状态
    GetExporterState({ commit }, params) {
      return new Promise((resolve, reject) => {
        getExporterState(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询进口商状态
    GetImporterState({ commit }, params) {
      return new Promise((resolve, reject) => {
        getImporterState(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 发送还价
    SendCounterOffer({ commit }, params) {
      return new Promise((resolve, reject) => {
        sendCounterOffer(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 发送还价给卖方
    SendCounterToExporter({ commit }, params) {
      return new Promise((resolve, reject) => {
        sendCounterToExporter(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询现货集结单买方状态
    GetSpotAsmOfferBuyerState({ commit }, params) {
      return new Promise((resolve, reject) => {
        getSpotAsmOfferBuyerState(params).then((response) => {
          commit('SET_ROWS', response.Data.Datas)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetOfferNotes({ commit }, params) {
      return new Promise((resolve, reject) => {
        getOfferNotes(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    AddOfferNote({ commit }, params) {
      return new Promise((resolve, reject) => {
        addOfferNote(params).then(() => {
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    UpdateOfferNature({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateOfferNature(params).then(() => {
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    ImportCompanyCustomsData({ commit }, params) {
      return new Promise((resolve, reject) => {
        importCompanyCustomsData(params).then(() => {
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    GetCompanyCustomsData({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCompanyCustomsData(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    GetBackendCompanyCustomsData({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBackendCompanyCustomsData(params).then((response) => {
          commit('SET_ROWS', response.Data.Lists.datas)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    GetGoodsSourceUpdateInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        getGoodsSourceUpdateInfo(params).then((response) => {
          commit('SET_ROWS', response.Data.Lists.data)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    ImportImporters({ commit }, params) {
      return new Promise((resolve, reject) => {
        importImporters(params).then(() => {
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    GetBackendImporters({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBackendImporters(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    ImportTradingReference({ commit }, params) {
      return new Promise((resolve, reject) => {
        importTradingReference(params).then(() => {
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    GetBackendTradingReference({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBackendTradingReference(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    GetBackendEmail({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBackendEmail(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    GetBackendComments({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBackendComments(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    UpdateBackendEmailState({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateBackendEmailState(params).then(() => {
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    UpdateBackendComments({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateBackendComments(params).then(() => {
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    GetUserCollection({ commit }, params) {
      return new Promise((resolve, reject) => {
        getUserCollection(params).then((response) => {
          commit('SET_ROWS', response.Data.Res)
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    UpdateEmailInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateEmailInfo(params).then(() => {
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    AddRealTimeSource({ commit }, params) {
      return new Promise((resolve, reject) => {
        addRealTimeSource(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    AddBuyerOffer({ commit }, params) {
      return new Promise((resolve, reject) => {
        addBuyerOffer(params).then(() => {
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    DeleteCircleReviewBackend({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteCircleReviewBackend(params).then(() => {
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    ClearCutsBrochureStatus({ commit }, params) {
      return new Promise((resolve, reject) => {
        clearCutsBrochureStatus(params).then(() => {
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    ReadBeefCircleReviews({ commit }, params) {
      return new Promise((resolve, reject) => {
        readBeefCircleReviews(params).then((response) => {
          commit('SET_REVIEWS', response.Data.Reviews)
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    // 查询所有分组聊天记录
    GetAllBeefChat({ commit }, params) {
      return new Promise((resolve, reject) => {
        getAllBeefChat(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询详细分组聊天记录
    GetBeefChatDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBeefChatDetail(params).then(response => {
          commit('SET_CHATTOTAL', response.Data.Total)
          commit('SET_CHATROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 聊天记录添加违规标记
    UpdateChatManageStatus({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateChatManageStatus(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    TopBeefCircle({ commit }, params) {
      return new Promise((resolve, reject) => {
        topBeefCircle(params).then(() => {
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    GetChatUserDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        getChatUserDetail(params).then((response) => {
          commit('SET_ROW', response.Data.Row.data)
          resolve()
        }).catch(() => {
          reject()
        })
      })
    }
  }
}
export default bdnote



// WEBPACK FOOTER //
// ./src/store/modules/trade.js